// The volume slider's scale: 0 to 500,000 calls a month on a curve.
//
// A straight scale over that range gives the first thousand calls a sliver of
// the track, and that is where most deals are. A cube puts 4,000 calls at a
// fifth of the way and 62,500 at halfway, so small deals get room and the
// largest are still in reach. The range is fixed: it never moves with the
// value, so a drag cannot stretch it and a reload cannot change it.

export const SLIDER_MAX_CALLS = 500_000;
/** Positions along the track: fine enough that a step is never a jump at the low end. */
export const SLIDER_STEPS = 1_000;
const CURVE = 3;

/** Calls a month at a slider position, snapped to a figure a person would say. */
export function callsAtPosition(position: number): number {
  const share = Math.min(Math.max(position, 0), SLIDER_STEPS) / SLIDER_STEPS;
  return roundCalls(SLIDER_MAX_CALLS * share ** CURVE);
}

/** Where a volume sits on the track; past the top end, at the top. */
export function positionOfCalls(calls: number): number {
  const share = Math.min(Math.max(calls, 0), SLIDER_MAX_CALLS) / SLIDER_MAX_CALLS;
  return Math.round(SLIDER_STEPS * share ** (1 / CURVE));
}

function roundCalls(calls: number): number {
  const step = calls < 1_000 ? 10 : calls < 10_000 ? 50 : calls < 100_000 ? 500 : 5_000;
  return Math.round(calls / step) * step;
}
